import { ACTUALIZAR_LIST_CONSUMOS, AGREGAR_CONSUMO } from "./consumosActions";

  const consumosReducer = (state, action) => {
    switch(action.type){

        case ACTUALIZAR_LIST_CONSUMOS: {
            return {
                ...state,
                consumosList: action.payload
            }
        };

        case AGREGAR_CONSUMO:{
            return {
                 ...state,
                 consumosList: [action.payload, ...state.consumosList]
             }
        };

        default:
            return state;
    }
  }

  export default consumosReducer;